var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "style-sub-item" }, [
    _vm.title
      ? _c(
          "div",
          { staticClass: "sub-item-title", on: { click: _vm.toggleContent } },
          [
            _c("i", {
              staticClass: "el-icon-caret-right",
              class: { "is-expanded": _vm.isExpanded },
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.title))]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "sub-item-content",
        class: { "is-expanded": !_vm.title ? true : _vm.isExpanded },
        style: { "padding-top": !_vm.title || !_vm.isExpanded ? "0" : "12px" },
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }